export default function (domain) {
  return domain.split('.')[0]
}
